import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT } from '../fragments'

export const APPLY_TIP_VARIANT = gql`
  mutation ApplyTipVariant($amount: Float!, $tipVariantId: ID) {
    applyTipVariant(input: { amount: $amount, tipVariantId: $tipVariantId }) {
      cart {
        ...ShopCart
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
`
